import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getAccountName} from 'src/openapi/admin/apis/GetAccountNameApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    userSearchResultAccountsActions,
    userSearchResultAccountsDataSelector,
    userSearchResultAccountsResultSelector,
} from '../slices/user-search-result-accounts.slice';
import {userSearchResultStateSelector} from '../slices/user-search-result-state.slice';

import type {UserSearchResultCacheKeys} from '../typedef';

type Props = {
    accountIds: number[],
    totalCount: number,
};

export const useGetUserSearchResultAccounts = ({accountIds, totalCount}: Props) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback(() => apiDispatch(getAccountName({
        requestBody: [...new Set(accountIds)],
    })), [accountIds, apiDispatch]);

    const setLoadedData = useCallback((
        response: Record<string, string>,
        dataCacheKeys: UserSearchResultCacheKeys,
    ) => {
        dispatch(userSearchResultAccountsActions.onSuccess(({
            cacheKeys: dataCacheKeys,
            totalCount,
            data: response,
        })));
    }, [totalCount, dispatch]);

    return useCachedTable({
        dataSelector: userSearchResultAccountsDataSelector,
        stateSelector: userSearchResultStateSelector,
        resultSelector: userSearchResultAccountsResultSelector,
        actions: userSearchResultAccountsActions,
        getAction,
        onSuccessLoad: setLoadedData,
        shouldClearOnUnmount: false,
    });
};
